import type { TabKey } from "@/components/GuidedRow";

/** Stem keys aligned with stem separation / download UI. */
export type MusicStemCustomDataKey = "vocals" | "drums" | "bass" | "other";

export type MusicEditorCustomDataKey =
  | TabKey
  | "prompt"
  | "lyrics"
  | "experience"
  | MusicStemCustomDataKey
  | "songfor"
  | "occasion"
  | "musicStyles"
  | "name"
  | "qualities";

/** Editor-only metadata stored in queryData / doc profile customProps (not music/generation API). */
export interface MusicEditorCustomData {
  prompt?: string;
  /** Serialized lyrics sections (JSON) or plain text; never shown in the prompt area. */
  lyrics?: string;
  genre?: string;
  style?: string;
  tempo?: string;
  instruments?: string;
  bpm?: string;
  key?: string;
  vocalMode?: string;
  vocalStyle?: string;
  language?: string;
  experience?: string;
  vocals?: string;
  drums?: string;
  bass?: string;
  other?: string;
  songfor?: string;
  occasion?: string;
  musicStyles?: string;
  name?: string;
  qualities?: string;
}

export const MUSIC_EDITOR_CUSTOM_DATA_KEYS: readonly MusicEditorCustomDataKey[] = [
  "prompt",
  "lyrics",
  "genre",
  "style",
  "tempo",
  "instruments",
  "bpm",
  "key",
  "vocalMode",
  "vocalStyle",
  "language",
  "experience",
  "vocals",
  "drums",
  "bass",
  "other",
  "songfor",
  "occasion",
  "musicStyles",
  "name",
  "qualities",
] as const;
